import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const scrollToContact = () => {
    const target = document.querySelector('#contact-cta');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleBookAppointment = (event) => {
    if (event) event.preventDefault();
    setIsMobileMenuOpen(false);

    if (location.pathname === '/') {
      scrollToContact();
    } else {
      navigate('/');
      setTimeout(scrollToContact, 120);
    }
  };

  const NavLink = ({ to, children, mobile = false }) => {
    const active = isActive(to);
    const baseClasses = mobile
      ? "block w-full text-center transition-colors font-medium py-2"
      : "transition-colors font-medium border-b-2 hover:border-primary pb-1";

    const activeClasses = mobile
      ? "text-primary"
      : "text-primary border-primary";

    const inactiveClasses = mobile
      ? "text-slate-600 dark:text-slate-300 hover:text-primary"
      : "text-slate-600 dark:text-slate-300 border-transparent hover:text-primary hover:border-primary/50";

    const handleClick = () => {
      setIsMobileMenuOpen(false);
      window.scrollTo(0, 0);
    };

    return (
      <Link
        to={to}
        className={`${baseClasses} ${active ? activeClasses : inactiveClasses}`}
        onClick={handleClick}
      >
        {children}
      </Link>
    );
  };

  return (
    <nav className="fixed md:sticky top-0 left-0 w-full z-50 bg-white lg:bg-white/90 dark:bg-slate-900 lg:dark:bg-slate-900/90 backdrop-blur-md shadow-sm border-b border-slate-100 dark:border-slate-800 transition-all duration-300">
      <div className="container mx-auto px-4 md:px-12 py-2 md:py-3 flex justify-between items-center">
        <Link className="flex items-center gap-2 group" to="/">
          <img
            src="/images/logo.jpg"
            alt="Smile Care Dental Surgery"
            className="h-8 md:h-10 w-auto object-contain transition-transform group-hover:scale-105"
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center space-x-10 font-medium text-[15px]">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about-us">About Us</NavLink>
          <NavLink to="/treatments">Treatments</NavLink>
          <NavLink to="/gallery-page">Gallery</NavLink>

          <a
            className="bg-primary hover:bg-primaryDark text-white px-6 py-2.5 rounded-full transition-all shadow-md hover:shadow-lg flex items-center gap-2 text-sm font-semibold tracking-wide"
            href="#contact-cta"
            onClick={handleBookAppointment}
          >
            <i className="fas fa-calendar-check text-xs"></i>
            <span>Book Appointment</span>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden text-slate-600 dark:text-white text-2xl p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {/* Mobile Menu - Full Screen Overlay */}
      <div className={`fixed inset-0 z-[60] bg-white dark:bg-slate-900 flex flex-col h-screen min-h-screen transition-all duration-300 ease-in-out lg:hidden ${isMobileMenuOpen ? 'translate-x-0 visible opacity-100' : 'translate-x-full invisible opacity-0'}`}>

        {/* Mobile Menu Header */}
        <div className="container mx-auto px-6 py-4 flex justify-between items-center z-10 relative bg-white dark:bg-slate-900">
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
            <img src="/images/logo.jpg" alt="Logo" className="h-10 w-auto" />
          </Link>
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="text-slate-600 dark:text-white text-3xl p-2 hover:text-primary transition-colors"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Menu Content */}
        <div className="flex-1 flex flex-col items-center justify-center space-y-8 bg-white dark:bg-slate-900">
          <NavLink to="/" mobile>Home</NavLink>
          <NavLink to="/about-us" mobile>About Us</NavLink>
          <NavLink to="/treatments" mobile>Treatments</NavLink>
          <NavLink to="/gallery-page" mobile>Gallery</NavLink>

          <a
            className="bg-primary hover:bg-primaryDark text-white py-3 px-10 rounded-full font-bold shadow-lg active:scale-95 transition-transform text-lg"
            href="#contact-cta"
            onClick={handleBookAppointment}
          >
            Book Appointment
          </a>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
